export const defaultFontTokens = {
    'twist-font-family-cash-sans': "'Cash Sans', sans-serif",
    'twist-font-family-cash-sans-wide': "'Cash Sans Wide', sans-serif",
    'twist-font-family-cash-sans-mono': "'Cash Sans Mono', sans-serif",
    /*
    DEPRECATED
    */
    'twist-font-family-pilat': "'Pilat', sans-serif",
    'twist-font-family-pilat-wide': "'Pilat Wide', sans-serif",
    'twist-font-family-pilat-condensed': "'Pilat Condensed', sans-serif",
    'twist-font-family-pilat-compressed': "'Pilat Compressed', sans-serif",
    'twist-font-family-pilat-extended': "'Pilat Extended', sans-serif",
    'twist-font-family-pilat-narrow': "'Pilat Narrow', sans-serif",
    'twist-font-family-pp-neue-machina': "'PPNeueMachina', serif",
    'twist-font-family-dipthong': "'Diphtong Pixel OT', monospace"
};
